export default api => ({
    evolution: () => api.get('/snapshots/evolution'),
    capture: () => api.post('/snapshots', {}),
})
